module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding-top": "45px",
      "width": "100%"
    }
  }, [_c('x-header', {
    staticClass: "zdyheaderBlue",
    attrs: {
      "left-options": {
        showBack: false
      }
    }
  }, [_vm._v("取卵移植饮食宣教")]), _vm._v(" "), _c('swiper', {
    staticClass: "previewer-demo-img",
    attrs: {
      "show-desc-mask": false,
      "list": _vm.demo01_list
    },
    nativeOn: {
      "click": function($event) {
        _vm.show(_vm.demo01_index)
      }
    },
    model: {
      value: (_vm.demo01_index),
      callback: function($$v) {
        _vm.demo01_index = $$v
      },
      expression: "demo01_index"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('previewer', {
    ref: "previewer",
    attrs: {
      "list": _vm.list
    }
  })], 1), _vm._v(" "), _vm._m(0, false, false)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footerPromt"
  }, [_vm._v("如有疑问，请联系客服："), _c('a', {
    staticStyle: {
      "color": "#4ba7e8"
    },
    attrs: {
      "href": "tel:02782889968"
    }
  }, [_vm._v("027-82889968")]), _vm._v("，感谢您的支持！")])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d21d6ae8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/articleProject/qlxj.vue
// module id = XVe2
// module chunks = 6